const inflight = new Map<string, number>();
const DEFAULT_COOLDOWN_MS = 3000;
const HEAVY_COOLDOWN_MS = 8000;

const HEAVY_PREFIXES = ['use-cases-', 'vs-', 'vp-', 'enrich-', 'incumbents-', 'vendor-intel', 'competitor-intel', 'tier-', 'triggers-'];

function getCooldown(key: string): number {
  for (const prefix of HEAVY_PREFIXES) {
    if (key.startsWith(prefix)) return HEAVY_COOLDOWN_MS;
  }
  return DEFAULT_COOLDOWN_MS;
}

export function canInvokeEdgeFn(key: string): boolean {
  const last = inflight.get(key);
  const cooldown = getCooldown(key);
  if (last && Date.now() - last < cooldown) return false;
  inflight.set(key, Date.now());
  return true;
}

export function releaseEdgeFn(key: string): void {
  inflight.delete(key);
}
